<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">用药编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="用药组名称" required prop="groupName">
                                    <el-input v-model="editForm.groupName"  placeholder="请输入用药组名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="用药组状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="请选择状态" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="用药详情" required prop="itemNameArr">
                                    <div style="width:100%;margin-top:40px">
                                        <el-tag
                                            :key="tag"
                                            v-for="tag in editForm.itemNameArr"
                                            closable
                                            :disable-transitions="false"
                                            @close="handleClose(tag)">
                                            {{tag}}
                                        </el-tag>
                                        <el-input
                                            class="input-new-tag"
                                            v-if="inputVisible"
                                            v-model="inputValue"
                                            ref="saveTagInput"
                                            size="small"
                                            @keyup.enter.native="handleInputConfirm"
                                            @blur="handleInputConfirm">
                                        </el-input>
                                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 药品添加</el-button>
                                    </div>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {getStaffCode} from "@/utils/auth";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: "Edit",
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    groupName:'',
                    elderlyCode:'',
                    status:'',
                    medicationGroupCode:'',
                    itemNameArr:[],
                },
                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                inputVisible: false,
                inputValue: '',
                rules:{
                    groupName:[
                        { required: true, message: '请输入用药组名称', trigger: 'blur' },
                    ],
                    itemNameArr:[
                        { required: true, message: '请输入描述', trigger: 'blur' },
                    ],

                }
            }
        },

        methods: {
            init(row){
                this.editForm.elderlyCode=row.elderlyCode
                this.editForm.status=row.status
                this.editForm.medicationGroupCode=row.medicationGroupCode
                this.editForm.groupName=row.name
                var list=[]
                var medicationItemList=row.medicationItemList
                for(var i in medicationItemList){
                    list[i]=medicationItemList[i].name
                }
                this.editForm.itemNameArr=list
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            handleClose(tag) {
                this.editForm.itemNameArr.splice(this.editForm.itemNameArr.indexOf(tag), 1);
            },
            showInput() {
                this.inputVisible = true;
                this.$nextTick(value => {
                    console.log(value)
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.editForm.itemNameArr.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            addSubmit(){

                this.loading = true;

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"MedicationGroup/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }
</script>
<style>
  .el-tag{
    margin-right: 10px;
  }
  .button-new-tag {
    height: 35px;
    line-height: 35px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 120px;
    vertical-align: bottom;
  }
</style>
<style lang="scss" scoped>
    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>